export default {
  submitButton: {
    id: 'checkout_step_addresses_submit_button',
    defaultMessage: 'Next',
  },
}
